import React, { useState } from "react";
import { Mail, RefreshCcw } from "lucide-react";
import Integration from "../Integration";
import { DataState } from "../../context/DataProvider";

const NoMailScreen = ({
  isOutlook=true,
  noneAuthenticated,
  isGmailSynchronized,
  isOutlookSynchronized
}) => {
  const [isSyncing, setIsSyncing] = useState(false);
  const [showIntegration, setShowIntegration] = useState(false);
  const { userGoogleId } = DataState();

  const handleSync = () => {
    setIsSyncing(true);

    // Simulate async sync operation
    setTimeout(() => {
      console.log("Sync email triggered");
      setIsSyncing(false);
    }, 2000); // Replace with actual sync logic
    setShowIntegration(true);
  };

  return (
    <div className="h-full text-gray-300 flex flex-col items-center justify-center p-4">
      {/* Mail Icon Box */}
      <div className="bg-gray-800 p-6 rounded-full mb-6 shadow-inner">
        <Mail className="w-10 h-10 text-gray-400" />
      </div>

      {/* Title */}
      <h2 className="text-2xl font-bold text-white mb-2">
        {noneAuthenticated ? "Connect your mailbox" : "No Emails Available"}
      </h2>

      {/* Subtext */}
      { (!isGmailSynchronized || !isOutlookSynchronized) ? (
        <p className="text-center max-w-md text-gray-500 mb-8">
        Please sync your {isOutlook ? "Outlook " : "Gmail "}
        account with our platform to start viewing your emails
        here.
      </p>

      ) : (
      <p className="text-center max-w-md text-gray-500 mb-8">
        Your mailbox isn’t connected yet. Please integrate your Gmail or Outlook
        account, then sync it with our platform to start viewing your emails
        here.
      </p>
    )}

      {/* Sync Button with loading */}
      <button
        disabled={isSyncing}
        onClick={handleSync}
        className={`flex items-center gap-2 bg-gray-700 text-white text-sm font-medium py-2 px-5 rounded-lg transition duration-200 ${isSyncing ? "opacity-60 cursor-not-allowed" : "hover:bg-gray-600"
          }`}
      >
        <RefreshCcw className={`w-4 h-4 ${isSyncing ? "animate-spin" : ""}`} />
        {noneAuthenticated ? (
          "Connect Mailbox"
        ) : (
          isSyncing ? "Syncing..." : "Sync Email"
        )}

      </button>
      {showIntegration && (
        <Integration onClose={() => setShowIntegration(false)} user_google_id={userGoogleId} onlyEmailApps={true} />
      )}
    </div>
  );
};

export default NoMailScreen;